<template>
  <l-control :position="position" class="leaflet-bar leaflet-control">
    <a v-for="(floor, index) in floors"
      href="#" @click="onSelect(index)"
      :title="floor.name"
      :class="state.index === index && floors.length > 1 && 'on'"
      :key="floor.id"
    >
      {{ floor.config && (typeof floor.config.number === 'number' ? floor.config.number : '') }}
    </a>
  </l-control>
</template>

<script>
import { LControl } from 'vue2-leaflet'

export default {
  props: {
    position: {
      type: String,
      default: 'topleft'
    },
    floors: {
      type: Array
    },
    number: {
      type: Number
    }
  },
  components: {
    LControl
  },
  data () {
    return {
      state: {
        index: 0
      }
    }
  },
  watch: {
    number () {
      if (this.number) {
        const index = this.floors.findIndex(floor => floor.config && floor.config.number === this.number)
        if (index !== -1) {
          this.state.index = index
        }
      }
    }
  },
  methods: {
    onSelect (index) {
      this.state.index = index
      this.$emit('change', this.floors[index])
    }
  }
}
</script>

<style scoped>
a.on {
  background-color: #007bff;
}

a.on i.fa {
  color: white;
}
</style>
